import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import { Location } from 'models/locations';

import CurrencySymbol from 'components/common/currency-symbol';

import SedanIcon from 'components/svgs/SedanIcon';
import VanIcon from 'components/svgs/VanIcon';
import TruckIcon from 'components/svgs/TruckIcon';
import SoldOut from 'components/checkout/add-ons/sold-out';

const propTypes = {
  location: PropTypes.instanceOf(Location).isRequired,
};

class AddOn extends React.Component {
  constructor(props) {
    super(props);

    this.changeOptionalAddOns = this.changeOptionalAddOns.bind(this);
    this.changeRequiredAddOns = this.changeRequiredAddOns.bind(this);
  }

  handleClick(e) {
    e.preventDefault();

    if (!this.props.selected) {
      this.props.onSelect(this.props.addOn);
    }
  }

  changeRequiredAddOns(e) {
    e.preventDefault();

    if (!this.props.selected) {
      this.props.onSelect(this.props.addOnType, this.props.addOn, 'replace');
    }
  }

  changeOptionalAddOns(event) {
    event.preventDefault();
    const action = this.props.selected ? 'remove' : 'add';
    this.props.onSelect(this.props.addOnType, this.props.addOn, action);
  }

  renderRequiredAddOn(humanDescription, price, iconURI, addOnItemNames) {
    const { addOn, location } = this.props;

    const unavailable = !addOn.isAvailable();
    const classes = cx({
      radio: true,
      mtn: true,
      selected: this.props.selected,
      disabled: unavailable,
      checkoutitem: true,
      addonitem: true,
      addonrow: true,
      row: true,
    });

    let priceClass;
    if (unavailable) {
      priceClass = 'col-xs-3 col-sm-2 add-on-price sold-out';
    } else {
      priceClass = 'col-xs-3 col-sm-2 add-on-price';
    }

    let items;
    if (addOnItemNames) {
      items = `(${addOnItemNames})`;
      if (unavailable) {
        items = <Fragment>{`(${addOnItemNames})`}{<SoldOut />}</Fragment>;
      }
    }

    let addOnIcon;
    if (iconURI) {
      if (iconURI.indexOf('sedan.png') !== -1) {
        addOnIcon = <SedanIcon />;
      } else if (iconURI.indexOf('van.png') !== -1) {
        addOnIcon = <VanIcon />;
      } else if (iconURI.indexOf('truck.png') !== -1) {
        addOnIcon = <TruckIcon />;
      }
    }

    return (
      <div className={classes} onClick={this.changeRequiredAddOns}>
        <div className="icons col-xs-1">
          <span className="add-on-radio" />
        </div>
        <div className="col-xs-3 col-sm-2">
          {addOnIcon}
        </div>
        <div className="col-xs-5 col-sm-6">
          <div className="row">
            <div className="add-on-description required col-sm-5 col-xs-12">
              {humanDescription}
            </div>
            <div className="add-on-items col-sm-7 col-xs-12">
              {items}
            </div>
          </div>
        </div>
        <div className={priceClass}>
          <span className="add-on-price-prefix">
            +
            <CurrencySymbol location={location} />
          </span>
          <span className="add-on-price-amount">
            { price }
          </span>
        </div>
      </div>
    );
  }

  renderOptionalAddOn(humanDescription, price, iconURI) {
    const { addOn, location } = this.props;
    const unavailable = !addOn.isAvailable();

    const classes = cx({
      checkbox: true,
      mtn: true,
      selected: this.props.selected,
      disabled: unavailable,
      checkoutitem: true,
      addonitem: true,
      optionaladdonrow: true,
      row: true,
    });

    let description;
    if (this.props.addOn.description) {
      description = `(${this.props.addOn.description})`;
    }

    let priceClass;
    if (unavailable) {
      price = (<FormattedMessage
        id="checkout.sold-out"
        defaultMessage="Sold Out"
      />);
      priceClass = 'col-xs-2 add-on-price sold-out';
    } else {
      priceClass = 'col-xs-2 add-on-price';
    }

    return (
      <div className={classes} onClick={this.changeOptionalAddOns} key={`add-on-${this.props.addOn.type}-${this.props.addOn.addOnId}`}>
        <label className="add-on-description col-xs-8">
          <span className="human-description">{humanDescription}&nbsp;</span>
          <span className="description">{description}</span>
        </label>
        <div className={priceClass}>
          <span className="add-on-price-prefix">
            +
            <CurrencySymbol location={location} />
          </span>
          <span className="add-on-price-amount">
            { price }
          </span>
        </div>
      </div>
    );
  }

  render() {
    const { addOn, required } = this.props;
    const { items, name, formattedPrice } = addOn;
    const addOnItemNames = items && items.length > 0 ? items.join(', ') : null;
    const iconUri = addOn.getImageURL();

    if (required) {
      return this.renderRequiredAddOn(name, formattedPrice, iconUri, addOnItemNames);
    }
    return this.renderOptionalAddOn(name, formattedPrice, iconUri);
  }
}

AddOn.propTypes = propTypes;

export default AddOn;
